@if(showSplash){
<div class="app-splash-screen" [ngStyle]="{left: windowWidth}">

   <div class="app-splash-screen-inner" class="mx-3">
      <mat-icon class="app-logo" svgIcon="lakal-logo-strip" aria-hidden="false" aria-label="LAKAL Logo"></mat-icon>
      <div class="app-label">Loading market information</div>
      <div class="app-loader"></div>
   </div>

</div>
}